<template>
  <section class="etouka">
    <base-container>
      <div class="header">
        <el-row justify="space-between">
          <el-col :sm="24" :md="11" :lg="11">
            <p>最新消息 - 12月日本代運免手續費</p>
          </el-col>
          <el-col :sm="24" :md="11" :lg="11">
            <el-button class="my-btn w3-right">所有通告</el-button>
          </el-col>
        </el-row>
      </div>
      <div class="content">
        <el-row justify="space-between">
          <el-col :sm="24" :lg="10">
            <img
              src="../../assets/img-etouka@2x.png"
              class="img-etouka"
              alt=""
            />
          </el-col>
          <el-col :sm="24" :lg="13">
            <div class="etouka-right-section">
              <h3 class="etouka-title">關於易到家 Etouka</h3>
              <p>
                方胡一怕豆春誰音誰活兆着忍坐發戶陽、高至蝶，同高字斗借六坐路兆什吧七大雲，刃家水頭跟東見合喝旁呀木，各久棵地春身安完嗎們牛氣圓，吹英隻位兔要枝習：具風主竹穿河再。
              </p>
              <br />
              <p>
                只食我鼻南交蝶巾玩七往安找，童禾發走只共躲寸次；貫那和事跟几六走紅帽念要訴語旁犬七出！三用光小胡屋！衣玩可。寸很一只合尾什課面怪五造？品在同甲水話坐地力念、麼左以。空只洋眼媽爬帶哪。
              </p>
            </div>
          </el-col>
        </el-row>
      </div>
    </base-container>
  </section>
</template>

<style scoped>
.container {
  padding: 0 16rem;
}

.etouka {
  padding-bottom: 2rem;
  padding-top: 2rem;
  min-width: 990px;
  background-color: #eee;
}

.etouka-title {
  color: #7a3d87;
  font-weight: 700;
  margin-top: -6rem;
}

.img-etouka {
  width: 100%;
}

.etouka .el-row {
  align-items: center;
}

.etouka .my-btn {
  border-radius: 100px;
  color: #fff;
  background-color: #b398c0d5;
  border-color: #8e819429;
  /* background-color: red; */
}

.etouka .my-btn:hover {
  background-color: #b398c0;
  border-color: #b398c0;
  /* background-color: red; */
}
.etouka .el-alert {
  background-color: #7a3d87 !important;
  border-radius: 12px;
  min-width: 1200px;
}

.etouka .header {
  background-color: #7a3d87 !important;
  border-radius: 12px;
  padding: 20px 24px;
  color: #fff;
  margin-bottom: 2rem;
  /* min-width: 480px; */
}

.content {
  background-color: #fff;
  padding: 3rem 1.5rem 1rem 1.5rem;
  border-radius: 12px;
  /* min-width: 480px; */
}

.etouka-right-section {
  width: 100%;
}

@media only screen and (max-width: 1193px) {
  .img-etouka {
    width: 100%;
    display: block;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 7rem;
  }
}
</style>